var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBell = function SvgBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD42F",
    d: "M14.285 7.486a2.511 2.511 0 1 1 0 5.024"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#969AAF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8,
    d: "M14.285 7.486a2.511 2.511 0 1 1 0 5.024M12.711 18.128 5.34 13.84V6.158L12.71 1.87a.88.88 0 0 1 1.322.76v14.74a.88.88 0 0 1-1.322.76z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#969AAF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8,
    d: "M3.181 6.157h2.16v7.682H3.18c-.93 0-1.685-.755-1.685-1.685V7.842c0-.93.754-1.685 1.685-1.685"
  })));
};
export default SvgBell;